export default {
  courseSelection: 'courseSelection',
  citySelection: 'citySelection',
  campusSelection: 'campusSelection',
  admissionType: {
    selection: 'admissionType.selection',
    essay: {
      themeSelection: 'admissionType.essay.themeSelection',
      supportText: 'admissionType.essay.supportText',
      write: 'admissionType.essay.write',
    },
    enem: {
      yearSelection: 'admissionType.enem.yearSelection',
      subscriptionNumber: 'admissionType.enem.subscriptionNumber',
      grades: 'admissionType.enem.grades',
    },
    secondGraduation: {
      institutionInfo: 'admissionType.secondGraduation.institutionInfo',
      documentation: 'admissionType.secondGraduation.documentation',
    },
    transferGraduation: {
      institutionInfo: 'admissionType.transferGraduation.institutionInfo',
      documentation: 'admissionType.transferGraduation.documentation',
    },
  },
  retryEssay: 'retryEssay',
  pendingApproval: 'pendingApproval',
  failure: 'failure',
  success: 'success',
};
